define('controller/step/datetime/SlotsDateTimeStep',['require','controller/step/datetime/BaseDateTimeStep','collection/TimeSlotCollection','view/controller/booking/datetime/slots/TimeSlotsView'],function (require) {

    var BaseDateTimeStep = require('controller/step/datetime/BaseDateTimeStep');
    var TimeSlotCollection = require('collection/TimeSlotCollection');
    var TimeSlotsView = require('view/controller/booking/datetime/slots/TimeSlotsView');

    return BaseDateTimeStep.extend({
        
    	_timeCollection: null,
    	
    	/**
    	 * Inits time collection
    	 */
    	_initTimeCollection: function () {
        	this._timeCollection = new TimeSlotCollection();
	    },

	    /**
	     * Returns time view
	     * 
	     * @return TimeSlotsView
	     */
        _getTimeView: function () {
        	var view = new TimeSlotsView({
        		model: this._bookingModel,
	    		bookingModel: this._bookingModel,
	    		collection: this._timeCollection,
                timeValidateModel: this._timeValidateModel,
				clientTimeZone: this.getOption('clientTimeZone'),
                showNavigation: this._supportsTimelineNavigation,
				waitingListHelperModel: this.getOption('waitingListHelperModel'),
	    	});
            
            this.listenTo(view, 'timeChanged', this._updateSelectedTime);
	    	
	    	return view;
        }
        
    });
    
});
